// @ts-check

/**
 * @file Helpers for making local Velocious database writes durable.
 */

import Configuration from "velocious/build/src/configuration.js"

/**
 * Flushes debounced local database persistence writes before code depends on
 * them surviving a browser reload.
 * @returns {Promise<void>} Resolves when local database writes are durable.
 */
export async function flushLocalDatabaseWrites() {
  await Configuration.current().ensureConnections({name: "Flush local database writes"}, async (dbs) => {
    await Promise.all(Object.values(dbs).map(async (db) => {
      await db.flushPendingWrites()
    }))
  })
}
